import 'rxjs/add/operator/take';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CanActivate, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { selectConfig } from './config.selector';
import { ConfigState } from './config.state';


/**
 * Guards are hooks into the route resolution process, providing an opportunity
 * to inform the router's navigation process whether the route should continue
 * to activate this route. Guards must return an observable of true or false.
 */
@Injectable()
export class ConfigLoadedGuard implements CanActivate, CanActivateChild {
    constructor(
        private store: Store<ConfigState>) { }

    /**
     * This method creates an observable that waits for the `loaded` property
     * of the collection state to turn `true`, emitting one time once loading
     * has finished.
     */
    waitForConfigToLoad(): Observable<boolean> {
        return this.store.select(selectConfig)
            .map(config => !!config)
            .filter(loaded => loaded)
            .take(1);
    }


    /**
     * This is the actual method the router will call when our guard is run.
     */
    canActivate(): Observable<boolean> {
        return this.waitForConfigToLoad();
    }


    canActivateChild(): Observable<boolean> {
        return this.canActivate();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.guard.ts